<button
    class="day"
    [disabled]="disabled"
    [ngClass]="{ selected: selected, exists: item.name != null, disabled: disabled, current: current, last: last }"
    (click)="selectItem()"
    attr.aria-selected="{{ selected || null }}"
    attr.aria-label="{{ fullDate }}"
    tabindex="{{ tabindex }}"
    #calendarDay
>
    {{ item.name }}
</button>
